import RoomList from '../pages/room-list/room-list'
import JoinFans from '../pages/join-fans/join-fans'
import Enhancements from '../pages/enhancements/enhancements'
import CheckOut from '../pages/check-out/check-out'
import RoomDetails from '../pages/room-details/room-details.vue'
import RoomsOverview from '../pages/rooms-overview/rooms-overview.vue'
import PrivilegesOverview from '../pages/privileges-overview/privileges-overview.vue'

export const BOOKING_ROUTE_NAMES = Object.freeze({
  ROOT: '/booking',
  ROOM_LIST: 'room-list',
  JOIN_FANS: 'join-fans',
  ENHANCEMENTS: 'enhancements',
  CHECK_OUT: 'check-out',
  ROOM_DETAILS: 'room-details',
  ROOMS_OVERVIEW: 'rooms-overview',
  PRIVILEGES_OVERVIEW: 'privileges-overview'
})

export const bookingRoutes = [
  { path: `${BOOKING_ROUTE_NAMES.ROOT}`, component: RoomList, name: BOOKING_ROUTE_NAMES.ROOM_LIST },
  { path: `${BOOKING_ROUTE_NAMES.ROOT}/join-fans`, component: JoinFans, name: BOOKING_ROUTE_NAMES.JOIN_FANS },
  { path: `${BOOKING_ROUTE_NAMES.ROOT}/enhancements`, component: Enhancements, name: BOOKING_ROUTE_NAMES.ENHANCEMENTS },
  { path: `${BOOKING_ROUTE_NAMES.ROOT}/check-out`, component: CheckOut, name: BOOKING_ROUTE_NAMES.CHECK_OUT },
  { path: `${BOOKING_ROUTE_NAMES.ROOT}/room/:id`, component: RoomDetails, name: BOOKING_ROUTE_NAMES.ROOM_DETAILS },
  { path: `${BOOKING_ROUTE_NAMES.ROOT}/rooms-overview`, component: RoomsOverview, name: BOOKING_ROUTE_NAMES.ROOMS_OVERVIEW },
  { path: `${BOOKING_ROUTE_NAMES.ROOT}/privileges-overview`, component: PrivilegesOverview, name: BOOKING_ROUTE_NAMES.PRIVILEGES_OVERVIEW },
]
